const getCookie = (cname) => {
  if (typeof document === 'undefined') return '';

  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');

  let found = ca.find((element) => element.startsWith(name) || element.startsWith(` ${name}`));
  if (found && found.length > 0) {
    found = found.trim().substring(name.length, found.length);
    if (found.startsWith('"')) found = found.substring(1);
    if (found.endsWith('"')) found = found.substring(0, found.length - 1);
    return found;
  }
  return '';
};

const cookieExists = (cookieName) => {
  const cookieValue = getCookie(cookieName) || '';
  return cookieValue.length > 0;
};

export const isLoggedIn = () => {
  if (typeof window !== 'undefined' && window.THDCustomer) {
    const { isLoggedIn: loggedInStatus } = window.THDCustomer.default;
    return loggedInStatus;
  }
  return null;
};

export const isB2BUser = () => {
  if (isLoggedIn()) {
    const { isB2BCustomer } = window.THDCustomer.default;
    return isB2BCustomer;
  }
  return null;
};

export const isInternalUser = () => cookieExists('internalUser');

export const getSiteInfo = () => getCookie('HD_DC');

export const getLoggedInUserInfo = () => {
  if (typeof window !== 'undefined' && window.THDCustomer) {
    const { email, svocID } = window.THDCustomer.default;
    return {
      identityId: svocID,
      email,
    };
  }
  return {};
};

export const getProfileId = () => {
  if (typeof window !== 'undefined' && window.THDCustomer) {
    const { svocID: ProfileId } = window.THDCustomer.default;
    return ProfileId;
  }
  return null;
};

export const getb2bProfile = () => {
  if (typeof window !== 'undefined' && window.THDCustomer) {
    const { role, userID, svocID } = window.THDCustomer.default;
    return {
      userType: role,
      userId: userID,
      accountId: svocID,
      shipToId: '',
      userTradeType: 'segment',
    };
  }
  return {};
};
